import { Box, Text } from '@fairfashion/design-system'

import { formatDateToDayMounthYear } from '../../utilities/masks/dates'

import * as Styles from './provider-risk.styles'
import { ProviderRisksProps } from './provider-risks.types'

export const ProviderRisks = ({
  socialEnvironmentalRisk,
}: ProviderRisksProps) => {
  const translateTypeOfRisk = (type: string | undefined) => {
    switch (type) {
      case undefined:
        return 'indefinido'
      case 'embargo':
        return 'embargo'
      case 'slavery':
        return 'Trabalho análogo a escravidão'
      case 'registration_status':
        return 'Situação cadastral'

      default:
        return type
    }
  }
  return socialEnvironmentalRisk && socialEnvironmentalRisk?.length > 0 ? (
    <Box width="100%" direction="column">
      {socialEnvironmentalRisk
        ?.slice()
        .sort((a, b) => {
          const dateA = a.date ? new Date(a.date).getTime() : 0
          const dateB = b.date ? new Date(b.date).getTime() : 0
          return dateB - dateA
        })
        .map((risk, index) => (
          <Box width="100%" alignItems="stretch" key={index}>
            <Box flex={1} direction="column" alignItems="center">
              <Styles.Circle active={index === 0} />
              <Styles.Line />
            </Box>
            <Box width="100%" paddingX={2} direction="column">
              <Box width="100%" gap={2} alignItems="center">
                <Text fontWeight={500}>
                  {risk.date && formatDateToDayMounthYear(risk.date)}
                </Text>
                <Styles.Bedge>
                  {translateTypeOfRisk(risk.typeRisk)}
                </Styles.Bedge>
              </Box>
              <Box
                width="100%"
                direction="column"
                paddingY={1}
                marginBottom={2}
              >
                <Text fontWeight={500}>{risk.summary}</Text>
                {risk.description &&
                  JSON.parse(risk.description).map(
                    (text: string, index: number) => (
                      <Text key={index}>{text}</Text>
                    ),
                  )}
                <Text color="grey_3">
                  <small>Fonte: {risk.fontRisk}</small>
                </Text>
              </Box>
            </Box>
          </Box>
        ))}
    </Box>
  ) : (
    <Box alignItems="center" justifyContent="center" width="100%" padding={6}>
      <Text align="center">Nenhum risco encontrado</Text>
    </Box>
  )
}
